export enum LOADING_STATUSES {
  LOADING = 'LOADING',
  SUCCEEDED = 'SUCCEEDED',
  FAILED = 'FAILED',
  IDLE = 'IDLE'
}